import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../../shared/services/notification.service';
import { PricingService } from '../../../shared/services/pricing.service';
import { SpecialPricingGroupFormComponent } from '../special-pricing-group-form/special-pricing-group-form.component';

@Component({
  standalone: false,
  selector: 'app-special-pricing-group-update',
  templateUrl: './special-pricing-group-update.component.html',
})
export class SpecialPricingGroupUpdateComponent implements OnInit {
  @ViewChild(SpecialPricingGroupFormComponent, { static: false }) form: SpecialPricingGroupFormComponent;

  loading = false;

  constructor(
    public pricingService: PricingService,
    public router: Router,
    public route: ActivatedRoute,
    public notificationService: NotificationService,
    titleService: Title
  ) {
    titleService.setTitle('Special group update');
  }

  ngOnInit() {
    this.loadGroupData();
  }

  afterSave() {
    this.router.navigate(['/pricing-special']).then();
  }

  private loadGroupData() {
    const id = parseInt(this.route.snapshot.params['id']);
    this.loading = true;

    this.pricingService.oneSpecialGroup(id).subscribe(
      group => this.initializeGroup(group, id),
      error => this.handleLoadGroupError(error)
    );
  }

  private initializeGroup(group: any, id: number) {
    group.bundles = [];
    group.tiers = [];

    const users = group.users;
    group.users = [];

    const errorHandler = err => this.handleLoadItemsError(err);

    if (group.paymentType === 'PREPAID') {
      this.loadBundles(id, group, users, errorHandler);
    } else {
      this.loadTiers(id, group, users, errorHandler);
    }
  }

  private loadBundles(id: number, group: any, users: any[], errorHandler: (err: any) => void) {
    this.pricingService.bundles(id).subscribe(items => {
      group.bundles = this.transformItems(items);
      this.populateForm(group, users);
    }, errorHandler);
  }

  private loadTiers(id: number, group: any, users: any[], errorHandler: (err: any) => void) {
    this.pricingService.tiers(id).subscribe(items => {
      group.tiers = this.transformItems(items);
      this.populateForm(group, users);
    }, errorHandler);
  }

  private transformItems(items: any[]) {
    return items
      .map(item => ({
        ...item,
        serviceType: item.serviceType === 'VOICE' ? 'CLI' : item.serviceType,
      }))
      .sort((a, b) => b.serviceType.localeCompare(a.serviceType));
  }

  private populateForm(group: any, users: any[]) {
    this.form.model = group;
    this.form.updatePackagesCount();

    setTimeout(() => {
      users.forEach(user => this.form.onSelectUser(user));
    }, 100);

    this.loading = false;
  }

  private handleLoadItemsError(err: any) {
    this.loading = false;
    this.notificationService.error({
      title: 'General pricing',
      message: 'An error occurred while loading the bundles/tiers',
      serviceName: 'GATEWAY',
      requestMessage: err.statusText,
      requestCode: err.status,
      ts: err.timestamp || null,
    });
  }

  private handleLoadGroupError(error: any) {
    this.loading = false;
    this.notificationService.error({
      title: 'Special pricing',
      message: 'An error occurred while loading the pricing group',
      serviceName: 'GATEWAY',
      requestMessage: error.statusText,
      requestCode: error.status,
      ts: error.timestamp || null,
    });
  }
}
